const ORIGIN = { collections: 'collections' }
export default ORIGIN
